import { render, staticRenderFns } from "./sub-head.vue?vue&type=template&id=11d54a4e&scoped=true&"
import script from "./sub-head.vue?vue&type=script&lang=js&"
export * from "./sub-head.vue?vue&type=script&lang=js&"
import style0 from "./sub-head.vue?vue&type=style&index=0&id=11d54a4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d54a4e",
  null
  
)

export default component.exports